// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"WidgetWrapper_wrapper__3a9Ay","clickable":"WidgetWrapper_clickable__1XjOA"};